// Fixedsidebar jQuery Plugin

$(function () {
    var FixedSidebar = function (element, options) {
        this.fixedSidebar = $(element);

        // Default module configuration
        this.defaults = {
            labels: {
                label1: 'label1',
                label2: 'label2',
            },
            classes: {
                class1: 'class1',
                class2: 'class2',
                states: {
                    active: 'is-active',
                },
            },
        };

        // Merge default classes with window.project.classes
        this.classes = $.extend(true, this.defaults.classes, (window.project ? window.project.classes : {}));

        // Merge default labels with window.project.labels
        this.labels = $.extend(true, this.defaults.labels, (window.project ? window.project.labels : {}));

        // Merge default config with custom config
        this.config = $.extend(true, this.defaults, options || {});

        this.publicMethods = {
            methodName: $.proxy(function () {
                // console.log('methodName function called');
            }, this),
        };

        this.init();
    };

    $.extend(FixedSidebar.prototype, {

        // Component initialization
        init: function () {
            this.bindEvents();
            this.fixWidget();
        },

        bindEvents: function () {
            $(window).bind('scroll', $.proxy(function () {
                this.fixWidget();
            }, this));
        },

        fixWidget: function () {
            var $window = $(window);
            var $actusWrapper = $('.actus-elements');
            var $sidebarContainer = $('.actus-social');
            // If not on mobile and if sidebar has height to get fixed (with margin for error)
            if ($window.width() > 767 && ($actusWrapper.height() - 50) > this.fixedSidebar.height()) {
                var containerPaddingTop = parseInt($sidebarContainer.css('padding-top').replace('px', ''));
                var containerPaddingBottom = parseInt($sidebarContainer.css('padding-bottom').replace('px', ''));
                var windowHeight = $window.height();
                var scrollPosition = $window.scrollTop();
                var containerOffset = ($sidebarContainer.offset().top + containerPaddingTop) - 25;
                // If sidebar hit top of window
                if ($sidebarContainer.length && this.fixedSidebar.length && this.fixedSidebar.height() < windowHeight) {
                    if (scrollPosition > containerOffset) {
                        this.fixedSidebar.addClass('is-snapped');
                    } else {
                        this.fixedSidebar.removeClass('is-snapped');
                    }
                    // Snap to bottom
                    var pagePaddingBottom = parseInt($('.l-page').css('padding-bottom').replace('px', ''));
                    var $footer = $('.l-footer');
                    var footerOffset = $footer.offset().top;
                    // If footer offset is equal or smaller - avoid sidebar overlapping
                    if ((this.fixedSidebar.offset().top + this.fixedSidebar.height()) > (footerOffset - pagePaddingBottom - containerPaddingBottom)) {
                        this.fixedSidebar.addClass('is-bottom-snapped');
                    }
                    // When scroll up unsnapped from bottom
                    if ((scrollPosition + windowHeight) < (footerOffset - pagePaddingBottom) && this.fixedSidebar.hasClass('is-bottom-snapped')) {
                        this.fixedSidebar.removeClass('is-bottom-snapped');
                    }
                } else {
                    this.fixedSidebar.removeClass('is-snapped');
                    this.fixedSidebar.removeClass('is-bottom-snapped');
                }
            }
        },
    });

    $.fn.fixedSidebar = function (options) {
        this.each($.proxy(function (index, element) {
            var $element = $(element);

            // Return early if this $element already has a plugin instance
            if ($element.data('fixedSidebar')) return;

            // Pass options to plugin constructor
            var fixedSidebar = new FixedSidebar(element, options);

            // Add every public methods to plugin
            for (var key in fixedSidebar.publicMethods) {
                this[key] = fixedSidebar.publicMethods[key];
            }

            // Store plugin object in this $element's data
            $element.data('fixedSidebar', fixedSidebar);
        }, this));

        return this;
    };
});
